import React, { Component } from 'react';
import Lightbox from 'lightbox-react';
import 'lightbox-react/style.css';
//import LocalizedLink from './LocalizedLink';
import { FormattedMessage } from 'react-intl';


//import { FormattedMessage } from 'react-intl';
import styled from "@emotion/styled";
import { BikeImgThumb } from './SpecialsImg' // This only needs to be imported once in your app


//const bikesImage = require('../../../../assets/images/V7_011_Bike_2.jpg')



/*
const StyledLink = styled(LocalizedLink)`
color:white;
font-family:"Kozuka Gothic Pr6N EL";
text-decoration:none;

:hover{
text-decoration:none;
color:white;

}
}
`
*/




const StyledLightbox = styled(Lightbox)`
z-index:9999999 !important;


`


const Button = styled.div`
 display: flex;
align-items: center;
justify-content:center;width:330px;
height:50px;
border-radius:2px;
border-top:2px solid lightgrey;
//border-bottom:1px solid lightgrey;
//border-left:1px solid lightgrey;
//border-right:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-type:bold;
//font-weight:bold;
width:100%;
font-size:19px;

:hover{
background: rgba(68,68,68,.2);
letter-spacing:0px;


}


`
const Div = styled.div`

.ReactModal__Overlay ReactModal__Overlay--after-open{
z-index:9999999 !important;
}
`

/*
const StyledPopup = styled(Popup)`
left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`
*/

const customStyles = {
  overlay : {
    zIndex                   : 9999999,

  }
};

export default class AddBikesLightbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Div>
        <BikeImgThumb />



      </Div>
    );
  }
}
